<div class="d-flex flex-column gap-1 align-items-center">
  <h4 class="text-black" [ngClass]="{ 'mb-5': isSpecialPack }">
    Commandez votre nouveau pack de crédits Perval : simple, performant et
    flexible. Laissez vous guider !
  </h4>
  <h6 class="align-self-end">
    Secteur couvert : France et DROM, hors Ile-de-France
  </h6>
</div>

<!-- Liste des packs -->
<div class="d-flex position-relative mt-5">
  <app-pack
    *ngFor="let pack of packs"
    [pack]="pack"
    (packSelected)="onPackSelected($event)"
  ></app-pack>
</div>

<div class="mt-3">
  <p>
    TTC calculé sur le montant de TVA applicable sur la France métropolitaine.
    Hors France métropolitaine, se référer à la TVA applicable sur le territoire
    concerné.
  </p>
</div>

<!-- Choix du renouvellement automatique (masqué pour les clients CB) -->
<div class="d-flex align-items-center mt-5" *ngIf="!isCB">
  <strong class="me-2">
    Renouvellement automatique
    <span *ngIf="spacialPackDescription">**</span>
    <span *ngIf="!spacialPackDescription">*</span>
  </strong>
  <div class="d-inline-block" class="choix-renouvellement-auto">
    <button
      id="btn-activer-renouvellement-auto"
      [ngClass]="{ active: renouvellementAuto }"
      [disabled]="isSpecialPackSelected"
      [attr.title]="activerRenouvellementAutoTitle"
      (click)="setRenouvellementAutoValue(true)"
    >
      Oui
    </button>
    <button
      id="btn-desactiver-renouvellement-auto"
      [ngClass]="{ active: renouvellementAuto === false }"
      title="Désactiver le renouvellement automatique"
      (click)="setRenouvellementAutoValue(false)"
    >
      Non
    </button>
  </div>
</div>

<!-- Boutons commander/payer et annuler -->
<div class="row d-flex justify-content-center w-100 mt-5">
  <p-button
    id="btn-commander"
    [label]="isCB ? 'Payer' : 'Commander'"
    level="primary"
    [width]="100"
    class="col-md-3 m-1"
    [disabled]="!canCommander"
    [title]="commanderButtonTitle"
    (click)="isCB ? onPayer() : onCommander()"
  ></p-button>
  <p-button
    id="btn-annuler"
    label="Annuler"
    level="secondary"
    type="button"
    [width]="100"
    class="col-md-3 m-1"
    routerLink="/commande-de-credits"
  ></p-button>
</div>

<!-- Mentions renouvellement (masquées pour les clients CB) -->
<div class="mt-5 mentions" *ngIf="!isCB">
  <p *ngIf="spacialPackDescription">* {{ spacialPackDescription }}</p>
  <p>
    <span *ngIf="spacialPackDescription">**</span>
    <span *ngIf="!spacialPackDescription">*</span>
    Renouvellement auto: Abonnement qui permet un réapprovisionnement
    automatique du montant de votre commande à épuisement de vos crédits. Si
    vous aviez déjà une commande active en renouvellement auto, cette nouvelle
    commande annule et remplace la commande précédente.
  </p>
</div>

<!-- Mention autoliquidation TVA (clients UE sans TVA intracommunautaire) -->
<div class="mt-3" *ngIf="isAutoliquidation">
  <p>
    Autoliquidation - TVA due par le preneur selon l'art. 196 de la directive
    2006/112/CE
  </p>
</div>
